import { render, staticRenderFns } from "./BusNameBadge.vue?vue&type=template&id=2458751c&"
import script from "./BusNameBadge.vue?vue&type=script&lang=js&"
export * from "./BusNameBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports